import React from 'react';
import styled, { keyframes } from 'styled-components';

export type Props = {
	width: number;
	height: number;
	cornerRadius?: number;
	opacity?: number;
	className?: string;
};

interface InternalProps {
	widthInternal: number;
	heightInternal: number;
	opacityInternal: number;
	cornerRadius: number;
}

const animation = keyframes`
	0% {
		background-position: top right;
	}
	100% {
		background-position: top left;
	}
`;

const elements = {
	shimmer: styled.div<InternalProps>`
		display: inline-block;
		width: ${({ widthInternal }) => widthInternal}px;
		height: ${({ heightInternal }) => heightInternal}px;
		opacity: ${({ opacityInternal }) => opacityInternal};

		.shimmer {
			border-radius: ${({ cornerRadius }) => cornerRadius}px;
			width: 100%;
			height: 100%;
			background-image: linear-gradient(-80deg, rgba(57, 57, 57, 0.2) 8%, rgba(0, 0, 0, 0.1) 18%, rgba(57, 57, 57, 0.2) 33%);
			background-repeat: no-repeat;
			background-position: 0 0;
			background-size: ${({ heightInternal, widthInternal }) => `${widthInternal * 10}px ${heightInternal}px`};
			animation-duration: 2s;
			animation-fill-mode: forwards;
			animation-iteration-count: infinite;
			animation-name: ${animation};
			animation-timing-function: ease-in-out;
			display: flex;
		}
	`,
};

// TODO: Move this to cortex

/**
 * # cortex:react-ui-std:comp:HeadlessPopover
 * Renders a "skeleton loading" body
 */
export function Shimmer({ className, width, height, opacity = 1, cornerRadius = 0 }: Props): JSX.Element {
	return (
		<elements.shimmer
			className={className}
			widthInternal={width}
			heightInternal={height}
			cornerRadius={cornerRadius}
			opacityInternal={opacity}
		>
			<div className='shimmer'></div>
		</elements.shimmer>
	);
}
